/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowFailureRecipientPostRequest
 */
export interface WorkflowFailureRecipientPostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkflowFailureRecipientPostRequest
     */
    email: string;
}

/**
 * Check if a given object implements the WorkflowFailureRecipientPostRequest interface.
 */
export function instanceOfWorkflowFailureRecipientPostRequest(value: object): value is WorkflowFailureRecipientPostRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function WorkflowFailureRecipientPostRequestFromJSON(json: any): WorkflowFailureRecipientPostRequest {
    return WorkflowFailureRecipientPostRequestFromJSONTyped(json, false);
}

export function WorkflowFailureRecipientPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowFailureRecipientPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function WorkflowFailureRecipientPostRequestToJSON(json: any): WorkflowFailureRecipientPostRequest {
    return WorkflowFailureRecipientPostRequestToJSONTyped(json, false);
}

export function WorkflowFailureRecipientPostRequestToJSONTyped(value?: WorkflowFailureRecipientPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

